module.exports = __webpack_public_path__ + "static/phone_@2x-bdccf02a8e914cb75d5372962109f507.png";